let listeners = [];
let currentLanguage = true; // Default to Finnish

if (typeof window !== "undefined") {
  // Check if running in the browser
  currentLanguage = localStorage.getItem("language") === "en" ? false : true;
}

export const getLanguage = () => currentLanguage;

export const toggleLanguage = () => {
  currentLanguage = !currentLanguage;

  if (typeof window !== "undefined") {
    localStorage.setItem("language", currentLanguage ? "fi" : "en");
  }

  listeners.forEach((callback) => callback()); // Notify all subscribers
};

export const subscribe = (callback) => {
  listeners.push(callback);
  return () => {
    listeners = listeners.filter((listener) => listener !== callback);
  };
};
